import { globalEventBus } from '../events'
import { setPlatformGlobals } from './utils'

setPlatformGlobals({ globalEventBus })
